export default {
  cardTypesResults(currentState, value) {
    const state = currentState;
    state.cardTypesResults = Object.assign([], value);
  },
};
